import { useEffect } from "react";
import { Routes, Route, BrowserRouter as Router } from "react-router-dom";
import { ConfigProvider } from "antd";
import Management from "./components/management/Management";
// import "antd/dist/antd.css"; // using below css import so that we change theme dynamically
import 'antd/dist/antd.variable.min.css';
import "./App.css";
import "./assets/styles/main.scss";
import ReactGA from "react-ga4";

ReactGA.initialize("G-YWVE4RD088");

ConfigProvider.config({
  theme: {
    primaryColor: '#7CB305',
  },
});

function App() {

  useEffect(() => {
    document.title = window.location.pathname
    ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search });
  }, []);

  return (
    <div>
      <Router>
        <Routes>
          <Route path="/management/:tutorialId" element={<Management />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
